import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class StorageService {
  private _token: string;

  get token(): string {
    return this._token;
  }

  set token(value: string) {
    this._token = value;
    const role = value["role"] || {};
    const roleName = role["name"] || "";
    const roleModules = role["modules"] || [];
    const redirectionModules =
      value["organization_modules"] && value["organization_modules"]["value"]
        ? value["organization_modules"]["value"]
        : roleModules;

    // setting local storage data
    window.localStorage.setItem("currentUser", JSON.stringify(value["token"]));
    window.localStorage.setItem("group", JSON.stringify(value["group"]));
    window.localStorage.setItem("name", JSON.stringify(value["name"]));
    window.localStorage.setItem("id", JSON.stringify(value["id"]));
    window.localStorage.setItem("userData", JSON.stringify(value));
    window.localStorage.setItem("role", JSON.stringify(roleName));
    window.localStorage.setItem(
      "session",
      JSON.stringify(value["session"] || null)
    );
    window.localStorage.setItem(
      "organization-modules",
      JSON.stringify(roleModules)
    );
    window.localStorage.setItem(
      "redirection-modules",
      JSON.stringify(redirectionModules)
    );
  }
}
